<div  [style.background-color]="customField25" class="commonHeader" fxLayout="row" fxLayoutAlign="space-between center">
    <span style="    font-size: 19px;
    font-weight: 500;">{{header | uppercase}}</span>

<button *ngIf="displayHeader" style="color:white" class="primary"
 (click)="goToCategory()" mat-raised-button>View All</button>
</div>

